var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var Encodings_1;
/* eslint-disable import/export */
import { JSON, JsonConverter, JsonSchemaV2, MapConverter } from '@symon-ai/wisepipe-serialize';
import { encodingsSchemaValidation } from '../validations.generated';
export const encodingsSchema = {
    $id: 'urn:wisepipe-common-pipe:Encodings',
    type: 'object',
    properties: {
        encodings: {
            type: 'object',
            additionalProperties: {
                type: 'array',
                items: { type: 'string', minLength: 1, maxLength: 150 },
                uniqueItems: true,
                minItems: 1,
                maxItems: 1000
            }
        }
    },
    required: ['encodings']
};
let Encodings = Encodings_1 = class Encodings {
    constructor(encodings) {
        this.encodings = new Map(encodings);
        JSON.validate(this, Encodings_1);
    }
    at(key) {
        return this.encodings.get(key);
    }
    has(key) {
        return this.encodings.has(key);
    }
    get size() {
        return this.encodings.size;
    }
    get names() {
        return Array.from(this.encodings.keys());
    }
    static merge(...encodings) {
        const merged = new Map();
        for (const encoding of encodings) {
            for (const kvp of encoding.encodings) {
                merged.set(kvp[0], kvp[1]);
            }
        }
        return new Encodings_1(merged);
    }
};
__decorate([
    JsonConverter(new MapConverter())
], Encodings.prototype, "encodings", void 0);
Encodings = Encodings_1 = __decorate([
    JsonSchemaV2(encodingsSchema, encodingsSchemaValidation)
], Encodings);
export { Encodings };
(function (Encodings) {
    Encodings.empty = new Encodings(new Map());
})(Encodings || (Encodings = {}));
//# sourceMappingURL=encodings.js.map